import React, { useState, useEffect, useContext, useRef } from 'react';
import { IProps, IUploadElement } from './types';
import selectors from '@state/selectors';
import Button from '@components/Button';
import * as S from './styles';
import C from '@assets/themes/colors';
import { IBrandImageType, IDSConfig, ISetDSConfigAction } from '@state/dsconfig/types';
import { useDispatch, useSelector } from 'react-redux';
import { BrandsContext, IBrandImageSection } from '@utils/DOIgnition/BrandsContext';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import { sendFile, copyFile } from '@utils/cloudStorage';
import { IElementUpdate, IActionInfo, IBrandFont } from '../../../../../../state/brands/types';
import { AdditionalMetadaTypesArray, IAdditionalMetadata, IBrandImage,IType } from '../../../../../../state/brandsImages/types';
import ComboBox from '@components/ComboBox';
import CustomTag from '@components/CustomTag';
import UploadBar from '@components/UploadBar';
import { flatten, uniqueId } from 'lodash';
import { getWidthHeightFromSrc } from '@utils/userUtils';
import { imageFileTypes, fontFileTypes } from '@utils/brand';
import { storageAccountName, containerNameBrands } from '@storage/azure-storage-blob';
import { getArrayBuffer } from '@utils/userUtils';
import { loadFont } from '@utils/fonts';
import VehiclesMetadata from './VehiclesMetadata';
import Metadata from './Metadata';
import MetadataInputs from './MetadaInputs';
import * as constants from './constants';
import { resizeImage, reduceImageFileSize, getBase64 } from 'utils/images'
const uuid = require('react-uuid');

const AddElement: React.FC<IProps> = (props) => {
  const authContext = useContext(AuthContext);
  const dsConfig: IDSConfig = useSelector(selectors.dsConfig.getDSConfig);
  const { brandDetail, addUpdateBrand, brandAction, setBrandAction } = useContext(BrandsContext);
  const section = brandAction.section as IBrandImageSection;
  const isFontSection = brandAction.section === "fonts";
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [metadata, setMetadata] = useState(false);
  const [filesUploaded, setFilesUploaded] = useState<IUploadElement[]>([]);
  const [filesUploadedFinish, setFilesUploadedFinish] = useState<boolean>(false);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [typesList, setTypesList] = useState<IType[]>([]);
  const [themes, setThemes] = useState<IType[]>([]);
  const [vehicleMetadata, setVehicleMetadata] = useState<IAdditionalMetadata>();
  const [tags, setTags] = useState<string[]>([]);
  const [folder, setFolder] = useState<string | undefined>(undefined);

  const types = dsConfig.brandsConfig[section]?.types ?? [];
  const hasCustomTag = dsConfig.brandsConfig[section]?.customTags ?? false;

  const dispatch = useDispatch();

  useEffect(() => {
    if (brandAction?.element === "new") handleUploadFile();
    else if (brandAction?.action === "metadata") {
      if (brandAction.element.types) setTypesList(brandAction.element.types);
      if (brandAction.element.themes) setThemes(brandAction.element.themes);
      if (isFontSection) setTags(brandAction.element.aliases);
      else setTags(brandAction.element.tags);
      setMetadata(true)
    };
  }, [brandAction]);

  const handleFocusBack = () => {
    setBrandAction({ ...brandAction, element: undefined });
    setIsSaving(false);
    window.removeEventListener('focus', handleFocusBack);
  }

  const clickedFileInput = () => {
    window.addEventListener('focus', handleFocusBack);
  }

  const handleUploadFile = () => {
    if (fileInputRef.current) (fileInputRef.current as any).click();
    clickedFileInput();
  }

  const onInputFileChange = (e: any) => {
    if (fileInputRef.current) {
      validateFiles((fileInputRef.current as any).files);
    }
    e.target.value = '';
  }

  const validateFiles = (files: File[]) => {
    let errorFiles: string[] = [];
    let newFiles: File[] = [];
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const fileTypes = isFontSection ? fontFileTypes : imageFileTypes;
      if (fileTypes.includes(file.type) || isFontSection) newFiles = [...newFiles, file];
      else errorFiles = [...errorFiles, file.name];
    }
    if (newFiles.length) {
      if (isFontSection) sendFontFiles(newFiles);
      else sendUploadingFiles(newFiles);
    }
  }

  const sendFileResponse = async (name: string, data: string, fontName?: string) => {
    try {
      await sendFile(name, data, dispatch, undefined, "brands");
    } catch (e) {
      console.error(e);
    }
  }

  const sendFontFiles = async (files: File[]) => {
    if (filesUploaded) {
      const userData = {
        email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
        name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
      };
      
      let newFolder = brandDetail.brand?.id ? brandDetail.brand.id : undefined;
      if (newFolder===undefined) {
        newFolder = uuid();
        setFolder(newFolder);
      }
      
      let newFilesUploaded: IUploadElement[] = [];
      await Promise.all(files.map(async file => {
        let newAction: IActionInfo = {
          user: userData,
          date: new Date(),
          action: "INSERT"
        }

        const id = uuid();
        const splittedName = file.name.split(".");
        const name = splittedName.slice(0, -1).join(".");
        const ext = splittedName.slice(-1)[0];
        
        let element: IBrandFont = {
          id: id,
          status: "ACTIVE",
          name: name,
          ext: ext,
          aliases: [],
          templatesCount: 0,
          designsCount: 0, 
          actions: [newAction],
        };
        
        let arrayBuffer = await getArrayBuffer(file);
        if (arrayBuffer) loadFont(`font-${id}`, arrayBuffer);
        let srcFile = await getBase64(file);
        if (srcFile) sendFileResponse(`${newFolder}/${brandAction.section}/${id}.${ext}`, srcFile, id);
        let updateInfoNew: IUploadElement = {
          action: "INSERT", //INSERT DELETE UPDATE
          field: brandAction.section.toUpperCase(),
          value: element,
        }
        newFilesUploaded = [...newFilesUploaded, updateInfoNew]
      }))
      setFilesUploaded(newFilesUploaded);
    }
  }

  const sendUploadingFiles = async (files: File[]) => {
    if (filesUploaded) {
      const userData = {
        email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
        name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
      };
      
      let newFolder = brandDetail.brand?.id ? brandDetail.brand.id : undefined;
      if (newFolder===undefined) {
        newFolder = uuid();
        setFolder(newFolder);
      }
      
      let newFilesInfo: IUploadElement[] = [];
      await Promise.all(files.map(async file => {
        let newAction: IActionInfo = {
          user: userData,
          date: new Date(),
          action: "INSERT"
        }
        const ext = file.type.split("/")[1].toUpperCase();
        const name = file.name.split(".").slice(0, -1).join();
        const id = uuid();
        
        let element: IBrandImage = {
          id: id,
          entityType: 'BRANDIMAGE',
          imageType: brandAction.section.toUpperCase(),
          brandId: '',
          srcImage: id,
          templatesCount: 0,
          designsCount: 0,
          actions: [newAction],
          status: "ACTIVE",
          name: name,
          format: ext,
          types: typesList,
          themes: themes,
          tags: tags,
          
          createdBy: userData,
          updatedBy: userData
        };
        
        let orgFileBase64 = (await getBase64(file));
        let dimensions = await getWidthHeightFromSrc(orgFileBase64 ?? "");

        let updateInfoNew: IUploadElement = {
          action: "INSERT", //INSERT DELETE UPDATE
          field: brandAction.section.toUpperCase(),
          value: element,
          file: file,
          base64: orgFileBase64,
          size: dimensions,
          loading: 20
        }
        newFilesInfo = [...newFilesInfo, updateInfoNew]
      }))
      setFilesUploaded(newFilesInfo);

      let newFilesUploaded: IUploadElement[] = [];
      await Promise.all(newFilesInfo.map(async newFile => {
        if (newFile.file) {
          let format = (newFile.file.name.toLocaleLowerCase().indexOf(".jpg")!==-1?"JPEG":"PNG");
          let dimensions = await getWidthHeightFromSrc(newFile.base64?? "");
          let imageThumbnailBase64 = undefined;
          if (dsConfig.clientImageProcessing && dsConfig.clientImageProcessing.thumbnailDefinition) {
            imageThumbnailBase64 = (await resizeImage(newFile.file, format, dsConfig.clientImageProcessing.thumbnailDefinition.width, dsConfig.clientImageProcessing.thumbnailDefinition.height, true)).toString();
            if (imageThumbnailBase64) sendFileResponse(`${newFolder}/${brandAction.section}/${(newFile.value as IBrandImage).srcImage}` + "TN", imageThumbnailBase64);
          }
          
          newFile.base64 = imageThumbnailBase64??newFile.base64;
          newFile.size = dimensions;
          newFile.loading =  60;
        }
        newFilesUploaded = [...newFilesUploaded, newFile];
      }))

      setFilesUploaded(newFilesUploaded);
      
      await Promise.all(newFilesUploaded.map(async (updateInfoNew: IUploadElement, index) => {
        if ( updateInfoNew.file ) {
          let format = (updateInfoNew.file.name.toLocaleLowerCase().indexOf(".jpg")!==-1?"JPEG":"PNG");
          let imageCompressedBase64 = undefined;
          if (dsConfig.clientImageProcessing && dsConfig.clientImageProcessing.imageMaxFileSize && dsConfig.clientImageProcessing.pixelResize) {
            imageCompressedBase64 = (await reduceImageFileSize(updateInfoNew.file, format, (dsConfig.clientImageProcessing.imageMaxFileSize * 1024),dsConfig.clientImageProcessing.pixelResize)??"").toString();
          }
          else {
            imageCompressedBase64 = (await getBase64(updateInfoNew.file));
          }
          if (imageCompressedBase64) sendFileResponse(`${newFolder}/${brandAction.section}/${(updateInfoNew.value as IBrandImage).srcImage}`, imageCompressedBase64);
       }
      }));
      setFilesUploadedFinish(true);
    }
  }

  const handleEditMetadata = () => {
    const userData = {
      email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
      name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
    };
    let newAction: IActionInfo = {
      user: userData,
      date: new Date(),
      action: "UPDATE"
    }
    let element: IBrandImage = {...brandAction.element};
    element.actions.push(newAction);
    if (typesList) element.types = typesList;
    if (themes) element.themes = themes;
    if (vehicleMetadata) element = {...element, ...vehicleMetadata};
    element.tags = tags;
    let updateInfoNew: IUploadElement = {
      action: "UPDATE", //INSERT DELETE UPDATE
      field: brandAction.section.toUpperCase(),
      value: element,
    }
    addUpdateBrand([updateInfoNew]);
  }

  const handleEditAlias = () => {
    const userData = {
      email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
      name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
    };
    let newAction: IActionInfo = {
      user: userData,
      date: new Date(),
      action: "UPDATE"
    }
    let element: IBrandFont = {...brandAction.element};
    element.actions.push(newAction);
    element.aliases = tags;
    let updateInfoNew: IUploadElement = {
      action: "UPDATE", //INSERT DELETE UPDATE
      field: brandAction.section.toUpperCase(),
      value: element,
    }
    addUpdateBrand([updateInfoNew]);
  }

  const handleAddElements = () => {
    setIsSaving(true);
    if (metadata) {
      if (isFontSection) handleEditAlias();
      else handleEditMetadata();
    } else if (filesUploaded.length > 0) {
      let newFilesUploaded = [...filesUploaded];
      
      newFilesUploaded.map(fileUploaded => {
        let value = {...fileUploaded.value} as IBrandImage;
        
        value.brandId = folder ?? brandDetail?.brand?.id;
        value.tags = tags;
        if (typesList) value.types = typesList;
        if (themes) value.themes = themes;
        if (vehicleMetadata) value = {...value, ...vehicleMetadata};

        fileUploaded.value=value;
      });
      
      addUpdateBrand(newFilesUploaded, undefined, folder, undefined, undefined, newFilesUploaded?.length ? `${newFilesUploaded?.length} ${isFontSection ? 'font':'file'}${newFilesUploaded?.length>1 ? 's':''} saved.` : undefined);
      setFolder(undefined);
    }
  }

  const handleSelectOption = (id: string, value: string) => {
    if (id === "type") {
      const i = typesList?.findIndex(_element => _element.id === id);
      if (i && i > -1) {
        let newTypes = [...typesList];
        newTypes[i] = {id: id, value: value};
        setTypesList(newTypes);
      } else setTypesList([...typesList, {id: id, value: value}]);
    }
  }

  const handleAddCustomTag = (value: string) => {
    setTags([...tags, value]);
  }

  const handleRemoveCustomTag = (index: number) => {
    setTags([...tags.slice(0, index), ...tags.slice(index + 1)]);
  }

  const handleAddAlias = (value: string, id?: string) => {
    const fileIndex = filesUploaded.findIndex(fileUploaded => fileUploaded.value.id === id);
    if (fileIndex >= 0) {
      const element = filesUploaded[fileIndex].value as IBrandFont;
      setFilesUploaded([
        ...filesUploaded.slice(0, fileIndex),
        {...filesUploaded[fileIndex], value: {...element, aliases: [...element.aliases, value]}},
        ...filesUploaded.slice(fileIndex + 1)
      ])
    } 
  }

  const handleRemoveAlias = (index: number, id?: string) => {
    const fileIndex = filesUploaded.findIndex(fileUploaded => fileUploaded.value.id === id);
    if (fileIndex >= 0) {
      const element = filesUploaded[fileIndex].value as IBrandFont;
      setFilesUploaded([
        ...filesUploaded.slice(0, fileIndex),
        {...filesUploaded[fileIndex], value: {...element, aliases: [
          ...element.aliases.slice(0, index),
          ...element.aliases.slice(index + 1)
        ]}},
        ...filesUploaded.slice(fileIndex + 1)
      ])
    } 
  }

  const getDisabled =  () => {
    if (isFontSection) return isSaving ? true : false;
    let dataValidate = true;
    if (props.elementName.toLocaleLowerCase() === "vehicle image" && (!vehicleMetadata || !vehicleMetadata.year || !vehicleMetadata.make || !vehicleMetadata.model || !vehicleMetadata.trim || vehicleMetadata.year === '' || vehicleMetadata.make === '' || vehicleMetadata.model === '' || vehicleMetadata.trim === '')) {
      dataValidate = false;
    }

    if (brandAction?.section === 'logos' && typesList?.length===0) dataValidate =  false;
    if (typesList?.length<=1 &&  brandAction?.section === 'backgrounds') dataValidate =  false;
    if ((typesList?.length==0 || themes?.length===0) &&  brandAction?.section === 'stocks') dataValidate =  false;
    if (!filesUploadedFinish && !metadata) dataValidate =  false;

    return isSaving || !dataValidate ? true : false;
  }

  const elementNameSplitted = props.elementName.split(' ');

  const getEndMetaDataMessage = ():string => {
    switch(props.elementName.toLocaleLowerCase()) {
      case "logo":
        return constants.MSG_META_DATA_ADD_LOGO;
      case "vehicle image":
        return constants.MSG_META_DATA_ADD_VEHICLE_IMAGE;
      default:
        return "";
    }
  }

  const getSingleOrBulkMessage = ():string => {
    switch(filesUploaded.length) {
      case 1:
        return constants.MSG_META_DATA_SINGLE_APPLY;
      default:
        return constants.MSG_META_DATA_BULK_APPLY;
    }
  }

  const handleMetadata = (values: IType[]) => {
    let find= values.find((item: IType)=> item.id==='theme');
    if (find===undefined) setTypesList([...values]);
    else setThemes([...values]);
  }
  
  React.useEffect(() => {
    if (metadata && brandAction?.section === "logos") {
      let newAdditionalMetadata: IAdditionalMetadata = {};
      AdditionalMetadaTypesArray.map(additionalType => {
        newAdditionalMetadata[additionalType] = brandAction?.element[additionalType];
      });
      setVehicleMetadata(newAdditionalMetadata);
    }
  }, [metadata]);

  return (
    <>
      <input
        ref={fileInputRef}
        id="fileInput"
        type="file"
        style={{ display: "none" }}
        onChange={onInputFileChange}
        accept={isFontSection ? fontFileTypes.join() : imageFileTypes.join()}
        multiple={true}
      />
      {
        (filesUploaded?.length || metadata) &&
        <S.Root style={{
          display: props.open ? 'flex' : 'none',
        }} >
          <S.BoxContainer
            widthValue={1010}
          >
            <S.TitleContainer>
              <S.LeftSide>
                <S.Title>
                  {metadata ? `Edit ${isFontSection ? 'Alias' : 'Metadata'}` : `Add ${elementNameSplitted[1] ?? elementNameSplitted[0]}`}
                </S.Title>
              </S.LeftSide>
            </S.TitleContainer>
            <S.Content>
              <S.Description>
                {metadata ? `Edit the ${isFontSection ? 'alias' : 'metadata fields'} of your ${props.elementName.toLocaleLowerCase()}.` : 
                  `You have the option to add ${isFontSection ? 'alias' : 'metadata'} for the ${props.elementName.toLocaleLowerCase()} you've uploaded. ${isFontSection ? `` : `${getSingleOrBulkMessage()} ${getEndMetaDataMessage()}`}`
                }
              </S.Description>
              <S.LoadContainer>
                {(!metadata && !isFontSection) && (filesUploaded.length > 1 ?
                  <S.LeftSectionContainer>
                    <S.FilesContainer>
                      {filesUploaded.map(fileUploaded =>
                        <S.FileRow>
                          <S.FileTitle>
                            {fileUploaded.file?.name}
                          </S.FileTitle>
                          {(fileUploaded.size) && 
                          <S.InfoContainer>
                            <S.FileSize>
                              {`${fileUploaded.size?.width}x${fileUploaded.size?.height} px`}
                            </S.FileSize>
                            <UploadBar width={25} height={8} progress={filesUploadedFinish? 100 : fileUploaded.loading??0} />
                          </S.InfoContainer>}
                          <S.FilePreviewContainer>
                            <S.FilePreview src={fileUploaded.base64} />
                          </S.FilePreviewContainer>
                        </S.FileRow>
                      )}
                    </S.FilesContainer>
                    <S.FilesNumberMessage>
                      {filesUploaded.length + " images"}
                    </S.FilesNumberMessage>
                  </S.LeftSectionContainer>
                  :
                  <S.Container style={{ display: 'inline-flex' }}>
                    <S.Images>
                      <S.ImgContainer width={147} src={filesUploaded[0].file ? URL.createObjectURL(filesUploaded[0].file) : ""} />
                      <S.TextInfo>{filesUploaded[0].file?.name}</S.TextInfo>
                      {
                        !isSaving && 
                        <S.FileSizeSingleImg>
                          {`${filesUploaded[0].size?.width}x${filesUploaded[0].size?.height} px`}
                        </S.FileSizeSingleImg>
                      }
                    </S.Images>
                  </S.Container>
                )}
                <S.FieldsContainer
                  rowValue={brandAction?.section !== "logos" && (metadata || isFontSection)}
                >
                  {
                    brandAction?.section === 'vehicles' &&
                    <VehiclesMetadata
                    onChange={(value: any) => setVehicleMetadata(value)}
                    vehicleMetadata={brandAction?.element?.year && brandAction?.element}
                    />
                  }

                  {brandAction?.section === 'fonts' && 
                    filesUploaded.map((fileUploaded, index) => {
                      const element = fileUploaded.value as IBrandFont;
                      return (
                        <S.Row
                          key={index}
                        >
                          <CustomTag
                            id={element.id}
                            items={element.aliases}
                            addItems={handleAddAlias}
                            removeItems={handleRemoveAlias}
                            disabled={false}
                            hideAuxText={true}
                            title='Set Alias As'
                            placeholder='Enter Alias'
                            containerStyle={{
                              width: "250px",
                              margin: "0px",
                            }}
                            titleStyle={{
                              fontFamily: "Roboto",
                              fontSize: "16px",
                              fontWeight: 500,
                              fontStretch: "normal",
                              fontStyle: "normal",
                              lineHeight: "normal",
                              letterSpacing: "normal",
                              textAlign: "left",
                              color: "#000",
                              margin: "0px 0px 7px 0px",
                            }}
                          />
                          <S.Font role="NewText" fontFamilyValue={`font-${element.id}`}>
                            {element.name}
                          </S.Font>
                        </S.Row>
                      )
                    })
                  }

                  {(brandAction?.section !== 'fonts' && brandAction?.section !== 'colors') && 
                    types.map((typeInfo, index) => {
                      if (!typeInfo.isInput) return (
                        <Metadata
                          key={index}
                          typeInfo={typeInfo} 
                          onChange={(value:IType[])=> handleMetadata(value)} 
                          metaData={(typesList && typeInfo.value!=='themes' ) ? typesList: themes ? themes : undefined}
                          edit={brandAction?.action === "metadata"}
                          section={brandAction?.section}
                        />
                      );
                    })
                  }
                  
                  { (hasCustomTag || (metadata && isFontSection)) &&
                    <CustomTag
                      items={tags}
                      addItems={handleAddCustomTag}
                      removeItems={handleRemoveCustomTag}
                      disabled={false}
                      hideAuxText={true}
                      title={isFontSection ? 'Set Alias As' : 'Tags'}
                      placeholder={isFontSection ? 'Enter Alias' : 'Enter Tags'}
                      containerStyle={{
                        width: "250px",
                        margin: "0px",
                      }}
                      titleStyle={{
                        fontFamily: "Roboto",
                        fontSize: "16px",
                        fontWeight: 500,
                        fontStretch: "normal",
                        fontStyle: "normal",
                        lineHeight: "normal",
                        letterSpacing: "normal",
                        textAlign: "left",
                        color: "#000",
                        margin: "0px 0px 7px 0px",
                      }}
                    />
                  }
                  { (metadata && isFontSection) &&
                    <S.Font role="NewText" fontFamilyValue={`font-${brandAction.element.id}`}>
                      {brandAction.element.name}
                    </S.Font>
                  }
                </S.FieldsContainer>
                <S.InputsContainer>
                  {
                    types.map((typeInfo, index) => {
                      if (typeInfo.isInput) return (
                        <MetadataInputs
                          key={index}
                          typeInfo={typeInfo}
                          additionalMetadata={vehicleMetadata}
                          onChange={(value: any) => setVehicleMetadata(value)}
                          edit={brandAction?.action === "metadata"}
                          isSaving={isSaving}
                        />
                      );
                    })
                  }
                </S.InputsContainer>
              </S.LoadContainer>
            </S.Content>
            <S.ActionsContainer>
              <S.Action>
                <Button
                  label="CANCEL"
                  style={{
                    width: '112px',
                    marginRight: 12,
                    backgroundColor: "transparent",
                    border: `1px solid ${C.BLUE}`,
                    hoverBackgroundColor: `${C.BLUE}22`,
                  }}
                  labelStyle={{ color: C.BLUE }}
                  onClick={() => setBrandAction(undefined)}
                  disabled={isSaving ? true : false}
                />
              </S.Action>
              <S.Action>
                <Button
                  label={isSaving ? "SAVING..." : metadata ? "SAVE" : "ADD"}
                  style={{
                    width: '112px',
                    backgroundColor: !getDisabled() && (typesList.length>0 || isFontSection) ? C.BLUE : C.GENERIC_GRAY,
                    flexGrow: 0,
                    hoverBackgroundColor: !getDisabled() && (typesList.length>0 || isFontSection) ? `${C.BLUE}AA` : `${C.GENERIC_GRAY}AA`,
                  }}
                  onClick={() => { if (typesList.length>0 || isFontSection) handleAddElements(); }}
                  disabled={getDisabled()}
                />
              </S.Action>
            </S.ActionsContainer>
          </S.BoxContainer>
        </S.Root>
      }
    </>
  );
}

export default AddElement;